import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { reduceResolution, wbp } from 'Theme';

export const useSingleSaleTableItemQuantityStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {},

        boxQty: {
            display: 'flex',
            alignItems: 'center'
        },

        typoQty: {
            display: 'flex',
            [theme.breakpoints.down(wbp)]: {
                paddingRight: `${reduceResolution(17)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                paddingRight: '17px'
            }
        },

        sectionIconQty: {
            'fontSize': 20,
            'display': 'flex',

            '&:hover': {
                cursor: 'pointer'
            }
        },

        typoAmount: {
            fontSize: 16,
            textAlign: 'center',
            padding: '0px 16px',

            [theme.breakpoints.up('md')]: {
                width: 28,
                paddingLeft: '10px',
                paddingRight: '10px'
            }
        }
    })
);
